// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://xoyfjixlaboxelsomnkq.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InhveWZqaXhsYWJveGVsc29tbmtxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDgzODg0OTEsImV4cCI6MjA2Mzk2NDQ5MX0.qQG8RGRpbBb1B6J3zEqr0XrKaAUTfWXGmKULRA2EDZw";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);